import { S140gS140m01Component } from './s140g-s140m01.component';

export { S140gModule } from './s140g.module';

export const S140gSubComponentsMap = {
	
};

export const S140gComponentsMap = {
	"s140g-s140m01": S140gS140m01Component
};

export const S140gComponents = [
	S140gS140m01Component
];

